var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sopimus-selaa" },
    [
      _c(
        "v-navigation-drawer",
        {
          ref: "offCanvas",
          attrs: { width: "450", app: "", right: "", temporary: "" },
          model: {
            value: _vm.showOffCanvas,
            callback: function ($$v) {
              _vm.showOffCanvas = $$v
            },
            expression: "showOffCanvas",
          },
        },
        [
          _vm.loadingOffCanvas
            ? _c("Spinner")
            : _c("OffCanvasSopimus", {
                on: {
                  "close-button-click": _vm.setShowOffCanvas,
                  messageSubmit: _vm.refresh,
                  "msg-mark-as-unread": _vm.refresh,
                  "msg-mark-as-read": _vm.refresh,
                },
                model: {
                  value: _vm.selectedItem.item,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedItem, "item", $$v)
                  },
                  expression: "selectedItem.item",
                },
              }),
        ],
        1
      ),
      _c("ViewSelaaTopBarBase", {
        attrs: {
          "pikahaun-placeholder-teksti": _vm.$t(
            "common:collectionBrowse.quickSearch"
          ),
          "vuex-module-name": _vm.vuexModuleName,
        },
        on: {
          "open-search-panel": _vm.openSearchPanel,
          "close-search-panel": _vm.closeSearchPanel,
        },
      }),
      _c("ViewSelaaTabs", {
        attrs: { "vuex-module-name": _vm.vuexModuleName },
      }),
      _c("TransitionSlidePanel", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchPanelOpen,
                expression: "searchPanelOpen",
              },
            ],
            staticClass: "pa-1 primary darken-1 shadow--inset",
          },
          [
            _c("InfoValittuValilehti", {
              attrs: { "current-tab": _vm.currentTab },
            }),
            _c("FormSearchSopimus", {
              model: {
                value: _vm.searchTerms,
                callback: function ($$v) {
                  _vm.searchTerms = $$v
                },
                expression: "searchTerms",
              },
            }),
          ],
          1
        ),
      ]),
      _c("ViewSelaaToolbar", {
        attrs: {
          "vuex-module-name": _vm.vuexModuleName,
          "item-partitiivi": _vm.$t("common:contractBrowse.repeatingInvoice"),
          "lataa-csv-btn-config": {
            csvData: _vm.csvData,
            csvLabels: _vm.csvLabels,
            csvTitle: _vm.csvTitle,
          },
          "uusi-btn-config": {
            toName: "sopimus-tallenna",
            itemName: "toistuva lasku",
            permission: _vm.$permission.checkSinglePerm(
              "onlinerestapi.onlinerestapi_sopimus_uusi"
            ),
          },
        },
      }),
      _c("v-data-table", {
        staticClass: "v-data-table--striped",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.items,
          "hide-default-footer": _vm.items.length < 10,
          "footer-props": {
            itemsPerPageOptions: [10, 25, 50, 100],
          },
          "multi-sort": true,
          "server-items-length": _vm.itemsTotal,
          options: _vm.pagination,
          loading: _vm.loading,
          "loading-text": "",
          "no-data-text": "",
          dense: _vm.tiivisNakyma,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "progress",
            fn: function () {
              return [
                _c("v-progress-linear", {
                  attrs: { color: "primary", indeterminate: "" },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "item",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "TableRow",
                  {
                    attrs: {
                      clickable: true,
                      data: item,
                      "selected-item": _vm.selectedItem.item,
                      fade: _vm.loading,
                      yellow: item.onko_myohassa,
                      "custom-contextmenu": true,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedItem({ item: item })
                      },
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.avaaMenuContext($event, item)
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "text-no-wrap" },
                      [
                        _c("v-tooltip", {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    item.ikoni_ja_vari
                                      ? _c("StatusIcon", {
                                          attrs: {
                                            icon: item.ikoni_ja_vari.ikoni,
                                            size: _vm.tiivisNakyma
                                              ? "small"
                                              : "medium",
                                            "hover-icon": "open-in-new",
                                            "bg-color": item.ikoni_ja_vari.vari,
                                            "event-listener": on,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "sopimus-nayta",
                                                params: { id: item.id },
                                              })
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("common:openRepeatingInvoice")
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.nro) + " "),
                    ]),
                    _c(
                      "td",
                      [
                        _vm._v(" " + _vm._s(item.paamies.nimi) + " "),
                        item.paamies.id
                          ? [_vm._v(" (" + _vm._s(item.paamies.id) + ") ")]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "td",
                      { staticClass: "max-width" },
                      [
                        _vm._v(" " + _vm._s(item.asiakas.nimi) + " "),
                        item.asiakas.nro
                          ? [_vm._v(" (" + _vm._s(item.asiakas.nro) + ") ")]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.tila.selite) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.id) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap text-right" }, [
                      _vm._v(" " + _vm._s(_vm.$date(item.alkamispaiva)) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap text-right" }, [
                      _vm._v(" " + _vm._s(_vm.$date(item.loppumispaiva)) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.viitteemme) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.viitteenne) + " "),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm.tyhjaTaulukko
        ? _c("TyhjaTaulukkoOtsikko", {
            attrs: {
              otsikko: _vm.$t("contractSave.youHaveNoRepeatingInvoices"),
            },
          })
        : _vm._e(),
      _vm.tyhjaTaulukko
        ? _c("ToolbarTyhjaTaulukko", {
            attrs: {
              ikoni: "library_add",
              taustavari: "success",
              teksti: _vm.$t("contractSave.newRepeatingInvoice"),
              infoteksti: _vm.$t("contractSave.noRepeatingInvoiceAddInfo"),
              naytaAina: true,
              "uusi-btn-config": {
                toName: "sopimus-tallenna",
                itemName: "toistuva lasku",
                permission: _vm.$permission.checkSinglePerm(
                  "onlinerestapi.onlinerestapi_sopimus_uusi"
                ),
              },
            },
          })
        : _vm._e(),
      _vm.pagesTotal > 1
        ? _c(
            "v-toolbar",
            { staticClass: "my-6 py-2 transparent", attrs: { flat: "" } },
            [
              _c("v-spacer"),
              _c("Pagination", {
                attrs: { length: _vm.pagesTotal, disabled: _vm.loading },
                model: {
                  value: _vm.pagination.page,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "page", $$v)
                  },
                  expression: "pagination.page",
                },
              }),
              _c("v-spacer"),
            ],
            1
          )
        : _vm._e(),
      _c("MenuContext", {
        attrs: {
          "onko-nakyvissa": _vm.menuContextNakyvissa,
          "position-x": _vm.menuContextX,
          "position-y": _vm.menuContextY,
          vaihtoehdot: _vm.menuContextVaihtoehdot,
        },
        on: {
          avaaValilehteen: _vm.avaaUudessaValilehdessa,
          "update:return-value": _vm.suljeMenuContext,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }